<app-tdo-progress-spinner *ngIf="isLoading" data-cy="organization-dialog-loading-spinner"></app-tdo-progress-spinner>
<div *ngIf="!isLoading" class="section" style="flex: 1; display: flex; flex-direction: column;" data-cy="organization-dialog-container">
  <div class="section-header" style="flex-basis: fit-content;" data-cy="organization-dialog-header">
    <div class="section-header-title" data-cy="organization-dialog-title">Organization Information.</div>
  </div>

  <div class="section-content" style="display: flex; flex-direction: column; flex: 1; padding: 0px 0px 0px 0px !important;" data-cy="organization-dialog-content">
    <!-- Main Content -->
    <div class="main-content-container" data-cy="organization-dialog-main-container">
      <app-organization-configuration
        [isDialogMode]="isDialogMode"
        [isViewOnly]="isViewOnly"
        [enumOrganizationTypeId]="enumOrganizationTypeId"
        [organizationId]="organizationId"
        [showOrganizationTypeSelection]="showOrganizationTypeSelection"
        (NewOrganizationID)="this.GetNewOrganizationID($event)"
        data-cy="organization-dialog-config-component">
      </app-organization-configuration>
    </div>

    <!-- Saving Indicator -->
    <div *ngIf="childComponent?.isSaving" style="text-align: center; padding: 10px; color: gray;" data-cy="organization-dialog-saving-indicator">
      <mat-spinner diameter="40" data-cy="organization-dialog-saving-spinner"></mat-spinner>
      <p data-cy="organization-dialog-saving-text">Saving, please wait...</p>
    </div>

    <!-- Footer Buttons -->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="organization-dialog-footer">
      <div style="flex: 1; margin-right: 6px;" data-cy="organization-dialog-footer-spacer"></div>
      <button
        (click)="close()"
        class="tdo-button tdo-close"
        style="margin-right: 6px;"
        [disabled]="childComponent?.isSaving"
        data-cy="organization-dialog-close-button">Close
      </button>
    </div>
  </div>
</div>
